// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","footer_inner_wrapper":"footer_footer_inner_wrapper__U8343","footer_inner_wrapper_text_box":"footer_footer_inner_wrapper_text_box__AYh8F"};